export default "__VITE_ASSET__ffe11929__"